import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPayroll = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1.5,
			width: 14,
			height: 13,
			rx: 1,
			fill: "#7EE9B0",
			fillOpacity: .25,
			stroke: "#83E4B1",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00247 5.42244V4.56323",
			stroke: "#83E4B1",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.29119 5.42236H7.54442C7.27633 5.42205 7.01651 5.51517 6.80965 5.68569C6.60279 5.85621 6.46181 6.09348 6.41095 6.3567C6.3601 6.61992 6.40255 6.89263 6.53101 7.12793C6.65947 7.36324 6.8659 7.54643 7.11481 7.646L8.88736 8.35485C9.13572 8.45478 9.34156 8.63801 9.46959 8.87311C9.59762 9.10821 9.63986 9.38054 9.58906 9.64338C9.53826 9.90622 9.39759 10.1432 9.19117 10.3137C8.98476 10.4841 8.72546 10.5774 8.45776 10.5776H6.71356",
			stroke: "#83E4B1",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00247 11.4368V10.5776",
			stroke: "#83E4B1",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPayroll;
